import {makeStyles} from "@material-ui/core/styles";
import React from "react";
import { connect } from "react-redux";
import ImportarOSTenantDialog from "./ImportarOSDialog";
import {getImportOSTenant} from "../../../actions/orderActions";


const useStyles = makeStyles(theme => ({

}));


const ImportarOSTenant = ({

                              getImportOSTenant
                          }) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);

    const closeDialog = () => {
        setOpen(false);
    }

    const cbImportOSTenant = (os, prioridade) => {
        console.log("cbImportOSTenant", os)
        getImportOSTenant(os, prioridade);
    }

    return (
    <React.Fragment>
         <ImportarOSTenantDialog isOpen={open} closeDialog={closeDialog} importOS={cbImportOSTenant}/>
    </React.Fragment>)

}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.id !== null,
    }
}


export default connect(mapStateToProps, {getImportOSTenant})(ImportarOSTenant)
